import { getDefaultExportFromCjs as r } from "./index.es224.js";
import { __require as o } from "./index.es44.js";
var t = /* @__PURE__ */ o();
const s = /* @__PURE__ */ r(t);
export {
  s as default
};
//# sourceMappingURL=index.es43.js.map
